<template>
  <div>
    <template v-if="$_.includes(inlineComponents, component)">
      <b-row align-h="center">
        <b-col cols="6" class="text-left">
          <span class="mr-3">{{ name }}</span>
          <inline-help
            v-if="description && description !== name"
            :id="`control-help-${vars[0].id}`"
            :title="name"
            :description="description"
          />
        </b-col>
        <b-col cols="6" class="d-flex align-items-center justify-content-end">
          <component
            v-bind:is="component"
            :vars="vars"
            :status-var="statusVar"
            class="mb-2">
          </component>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <div v-if="showLabel || $_.includes(componentsWithLabels, component)" class="mb-3">
        <strong>{{ name }}</strong> <span v-if="showUnits && vars[0].unit"> [{{vars[0].unit}}]</span>
        <inline-help
          class="pl-2"
          v-if="description && description !== name"
          :id="`control-help-${vars[0].id}`"
          :title="name"
          :description="description"
        />
      </div>
      <component
        v-bind:is="component"
        :vars="vars"
        :status-var="statusVar"
        class="mb-2">
      </component>
    </template>
  </div>
</template>

<script>
import InlineHelp from '@/components/services/service/InlineHelp';

export default {
  name: 'DisplayControl',
  props: {
    vars: {
      required: true,
      type: Array,
    },
    component: {
      required: true,
    },
    name: {
      required: true,
      type: String,
    },
    description: {
      required: false,
      default: '',
      type: String,
    },
    statusVar: {
      required: false,
      type: Object,
    },
    showLabel: {
      required: false,
      default: false,
      type: Boolean,
    },
    showUnits: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      componentsWithLabels: [
        'SliderSwitch',
      ],
      inlineComponents: [
        'SliderSwitch',
        'SchedulerButton',
      ],
    };
  },
  components: {
    InlineHelp,
  },
};
</script>

<style scoped>

</style>
